import { render, staticRenderFns } from "./project-report.vue?vue&type=template&id=956d0732"
import script from "./project-report.vue?vue&type=script&lang=js"
export * from "./project-report.vue?vue&type=script&lang=js"
import style0 from "./project-report.vue?vue&type=style&index=0&id=956d0732&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports